// Bundle language files
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fa from "./locales/fa.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import tr from "./locales/tr.json";
import vi from "./locales/vi.json";
import zh from "./locales/zh.json";

export const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  es: {
    translation: es,
  },
  ar: {
    translation: ar,
  },
  de: {
    translation: de,
  },
  hi: {
    translation: hi,
  },
  fa: {
    translation: fa,
  },
  it: {
    translation: it,
  },
  ja: {
    translation: ja,
  },
  ko: {
    translation: ko,
  },
  nl: {
    translation: nl,
  },
  pl: {
    translation: pl,
  },
  pt: {
    translation: pt,
  },
  ru: {
    translation: ru,
  },
  tr: {
    translation: tr,
  },
  vi: {
    translation: vi,
  },
  zh: {
    translation: zh,
  },
};
